
(function(template){
    define('vue!app/views/vue/e-reg-vue-app/components/shareWith/container',['Vue','vuex', 'vue!../../reusableComponents/segment', 'vue!./guestSelect', 'vue!./addGuest', 'vue!./guestList'],function(Vue,vuex, segment, guestSelect, addGuest, guestList){
        return {
            name:'shareWith',
            template:template,
            components: {
                segment: segment,
                'guest-select': guestSelect,
                'add-guest' : addGuest,
                'guest-list' : guestList
            },
            data: function(){
                return {
                    showAddGuest: false
                }
            },
            computed: _.extend(vuex.mapState('pmsCheckin', ['pmsBookingInfo']),{
                shareWithsAdded: function() {
                    return this.$store.getters['pmsCheckin/shareWithsAdded'];
                }
            }),
            methods: {
                toggleShowGuest: function(bool) {
                    this.showAddGuest = bool;
                },
                handleSubmit: function() {
                    this.showAddGuest = false;
                }
            },
            mounted: function() {
                this.$store.dispatch('pmsCheckin/fetchGroupMembers');
            }
        }
    })
})('<segment v-if="pmsBookingInfo.numOfGuests > 1" > <template v-slot:header> <i class="fas fa-user"></i> {{localization.roomReservation.pmsCheckIn.shareWithHeader}} </template> <template v-slot:body> <guest-list v-if="shareWithsAdded" /> <guest-select @handleTrailingOptionClick="toggleShowGuest" /> <add-guest @submit="handleSubmit" v-if="showAddGuest" /> </template> </segment>');
